import { Field } from "@ark-ui/react/field";
import type { ComponentProps } from "react";
import Label from "./Label/Label";
import Input from "./Input/Input";
import HelperText from "./HelperText/HelperText";
import ErrorText from "./ErrorText/ErrorText";
import Textarea from "./Textarea/Textarea";

type Props = ComponentProps<typeof Field.Root>;

const TextFieldRoot = ({ children, ...rest }: Props) => {
  return <Field.Root {...rest}>{children}</Field.Root>;
};

export const TextField = Object.assign(TextFieldRoot, {
  Label: Label,
  Input: Input,
  HelperText: HelperText,
  ErrorText: ErrorText,
  Textarea: Textarea,
});
